import axios from '@/libs/api.request'
import {genURLParams} from '@/libs/urlparamhelper';

export const exportExcel = (params, urlParams) => {
  return axios.request({
    url: '/third/rmfreevehicle/exportexcel' + genURLParams(urlParams),
    method: 'GET',
    credentials: 'include',
    data: params
  })
}

